// The homepage's day: the feed's stories updated in the last WINDOW_HOURS.
// Shared by the list's Top tab (RankedFeed) and the Topics row under it
// (2026-10-28), so both read the same stories.

import moment from 'moment-timezone'

// A rolling day never looks empty at 7am the way "today" does, and it spares
// the reader a scope control they didn't ask for.
export const WINDOW_HOURS = 24

export const ts = (iso) => (iso ? moment.utc(iso).valueOf() : 0)

export function storiesInWindow(stories, now = Date.now()) {
  const cutoff = now - WINDOW_HOURS * 60 * 60 * 1000
  const inWindow = stories.filter((s) => ts(s.updatedAt) >= cutoff)
  // A quiet morning must never show a near-empty page.
  return inWindow.length >= 8 ? inWindow : stories
}
